import { useContext, useEffect, useRef, useState } from 'react';
import { DContext } from '../../context/Datacontext';
import { fetchRecruitmentTableFilter } from '../services/fetchRequirement';
import { RiFileExcel2Fill } from "react-icons/ri";
import { fetchClients } from '../services/managerApi/clientsApi';
import { fetchAllUsers } from '../services/fetchGetUser';
import { fetchStatus } from '../services/managerApi/statusApi';
import { AiOutlineClear } from "react-icons/ai";
import { BiHistory } from "react-icons/bi";
import { fetchProfile } from '../services/profileAction';
import ProfileHistoryList from './ProfileAction/ProfileHistoryList';
import { renderCapitalize } from '../../utils/renderCapitalize';
import { formatNames } from '../../utils/formatNames';
import ProfileSubmission from './ProfileAction/ProfileSubmission';
import Loading from './Loading';
import FilterSearchReport from '../blocks/ui/FilterSearchReport';
import { fetchCompanyClientSpocs, fetchCompanySpocs } from '../services/managerApi/SPOCApis';
import { apiFetch } from '../services/fetchApi';
// import { FaLiraSign } from 'react-icons/fa';

export const RecruitmentTableFilterReport = () => {
    const { BeURL, showAlert, currentUser } = useContext(DContext)
    const [requirement, setRequirement] = useState(null)
    const [activeIndex, setActiveIndex] = useState('All')
    const [fromDate, setFromDate] = useState('')
    const [toDate, setToDate] = useState('')
    const [loading, setLoading] = useState(false)
    const [statusId, setStatusId] = useState([])
    const [clientId, setClientId] = useState('')
    const [teamleadId, setTeamleadId] = useState('')
    const [managerId, setManagerId] = useState('')
    const [recruiterId, setRecruiterId] = useState('')
    const [updatedByRecruiterId, setUpdatedByRecruiterId] = useState('')
    const [sanSpocId, setSanSpocId] = useState('')
    const [clientManager, setClientManager] = useState('')
    const [jobName, setJobName] = useState('')
    const [candidateName, setCandidateName] = useState('')
    const [mobileNumber, setMobileNumber] = useState('')
    const [emailId, setEmailId] = useState('')

    const [jobStatus, setJobStatus] = useState('')
    // const [empId, setEmpId] = useState('')

    const id = currentUser?._id

    // filters useState
    const [teamleadsList, setTeamleadsList] = useState([])
    const [recruitersList, setRecruitersList] = useState([])
    const [managersList, setManagersList] = useState([])
    const [clientsList, setClientsList] = useState([])
    const [statusList, setStatusList] = useState([])
    const [users, setUsers] = useState([])
    const [submittedOn, setSubmittedOn]= useState({
        from:'', to:''
    })
    const [scheduledDate, setScheduledDate] = useState({
        from: '',
        to: ""
    })
    const [joinedDate, setJoinedDate] = useState({
        from: '',
        to: ''
    })
    const [allSpocsList, setAllSpocsList] = useState([])
    const [job, setJob] = useState({})
    // const [empIdLists, setEmpIdLists] = useState([])
    const [showScheduledDateFilter, setShowScheduledDateFilter] = useState(false);
    // const [showJoinedDateFilter, setShowJoinedDateFilter] = useState(false)
    const [showClientFilter, setShowClientFilter] = useState(false)
    const [showStatusFilter, setShowStatusFilter] = useState(false)
    const [showTeamManagerFilter, setShowTeamManagerFillter] = useState(false)
    const [showTeamLeadFilter, setTeamLeadFilter] = useState(false)
    const [showSubmittedByFilter, setShowSubmittedByFilter] = useState(false)
    const [showUpdatedByFilter, setShowUpdatedByFilter] = useState(false)
    const [showSanSpocFilter, setSanSpocFilter] = useState(false)
    const [showClientSpocFilter, setShowClientSpocFilter] = useState(false)
    const [showJobStatusFilter, setJobStatusFilter] = useState(false)
    // const [showEmpListsFilter, setShowEmpListsFilters] = useState(false)
   const [profileHistory, setProfileHistory] = useState(null)

    // pagination states
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [totalPage, setTotalPage] = useState(0)
    const [total, setTotal] = useState(0)
    const [perPageTotal, setPerPageTotal] = useState(0)

    // Profile submission
    const [showSubmission, setShowSubmission] = useState(false)
    const [selectedData, setSelectedData] = useState({});

    const apiLock = useRef(false)

    const filterButton = [
        { label: 'All', title: 'All' },
        { label: 'Today', title: 'Today' },
        { label: 'YesterDay', title: 'YesterDay' },
        { label: '1W', title: 'This Week' },
        { label: '1M', title: 'This Month' },
        { label: '3M', title: 'Last 3-Month' },
        { label: '6M', title: 'Last 6-Month' },
        { label: '1Y', title: 'This Year' }
    ]

    const handlePagination = (dir) => {
        if (dir === "prev" && currentPage > 1) setCurrentPage((p) => p - 1);
        if (dir === "next" && currentPage < totalPage) setCurrentPage((p) => p + 1);
    };
    // fetch clients and users
    useEffect(() => {

        const fetchDatas = async () => {
            const companyId = currentUser?.company?.companyId
            if (!companyId) return
            await fetchClients(BeURL, showAlert, setClientsList, companyId)
            await fetchAllUsers(BeURL, showAlert, setUsers, companyId)
            await fetchStatus(BeURL, showAlert, setStatusList)
            // await fetchCandidateEmpId(BeURL, showAlert, setEmpIdLists)
        }
        fetchDatas()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser?.company?.companyId])

    useEffect(() => {

        if (currentUser.role === 'manager') {
            setManagerId(currentUser.id)
        }

        if (currentUser.role === 'teamlead') {
            setManagerId(currentUser?.reportingManager?.reporingManagerId)
            setTeamleadId(currentUser.id)
        }
    }, [currentUser.role, currentUser])

    useEffect(() => {
        if (!users.length > 0) return

        setManagersList(users.filter(user => user.role === 'manager'))
    }, [users])

    useEffect(() => {
        if (!users.length > 0 && (!managerId)) return

        setTeamleadsList(users.filter(user =>
            user.role === 'teamlead' &&
            (!managerId || user.reportingManager?.reporingManagerId === managerId)
        ))
    }, [users, managerId])

    useEffect(() => {
        if (!users.length > 0 && !teamleadId) return
        // setRecruitersList(users.filter(user => (user.role === 'recruiter' && user?.reportingTeamLead?.reportingTeamLeadId === teamleadId) || user.id === teamleadId))

        let filteredUsers = users.filter(user =>
            (user.role === "recruiter" &&
                user?.reportingTeamLead?.reportingTeamLeadId === teamleadId) ||
            user.id === teamleadId
        );

        // ✅ add current user if teamlead
        if (
            currentUser.role === "teamlead" &&
            !filteredUsers.some(u => u.id === currentUser.id)
        ) {
            filteredUsers.push(currentUser);
        }

        setRecruitersList(filteredUsers);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [users, teamleadId, managerId])

    // call fethREcruitment api 
    const safeFetchRequirement = async (params) => {

        if (apiLock.current) {
            // console.log(" Blocked duplicate API call");
            return
        }
        apiLock.current = true

        try {
            await fetchRecruitmentTableFilter(params)
        } catch (err) {
            console.error("API Error:", err)
        } finally {
            apiLock.current = false
        }
    }

    useEffect(() => {

        const getRequirements = async () => {

            try {

                await safeFetchRequirement({
                    BeURL,
                    setRequirement,
                    showAlert,
                    activeIndex,
                    id,
                    currentPage,
                    rowsPerPage,
                    setTotal,
                    setTotalPage,
                    setPerPageTotal,
                    clientId,
                    managerId,
                    teamleadId,
                    recruiterId,
                    clientManager,
                    jobName,
                    updatedByRecruiterId,
                    candidateName,
                    mobileNumber,
                    emailId,
                    jobStatus,

                    sanSpocId,
                    statusId,
                    fromDate,
                    toDate,
                    scheduledDate,
                    joinedDate,
                    submittedOn,
                    setLoading
                });


            } catch (err) {
                console.error("Error fetching Requirement:", err)
            }
        };
        getRequirements()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeIndex, id, currentPage, rowsPerPage, clientId, managerId, teamleadId, recruiterId, updatedByRecruiterId, clientManager, jobName, candidateName, mobileNumber, emailId, jobStatus, sanSpocId, statusId, fromDate, toDate, scheduledDate.from, scheduledDate.to, joinedDate.from, joinedDate.to,submittedOn.from, submittedOn.to])

    const handleRequirement = (label) => {
        setFromDate('')
        setToDate('')
        setScheduledDate({
            from: '',
            to: ''
        })
        setSubmittedOn({from:'', to:''
        })
        setJoinedDate({
            from: '', to: ''
        })
        setActiveIndex(label)
        setCurrentPage(1)
    }

    // filter button date range clear
    useEffect(() => {
        if (fromDate || toDate) {
            setActiveIndex("");
            setScheduledDate({
                from: "",
                to: ""
            })
            setSubmittedOn({
                from: "",
                to: ""
            })
            setJoinedDate({
                from: '', to: ''
            })
        }
    }, [fromDate, toDate]);

    useEffect(() => {
        if (scheduledDate.from || scheduledDate.to) {
            setActiveIndex("")
            setFromDate("")
            setToDate("")
            setJoinedDate({
                from: '', to: ''
            })
            setSubmittedOn({
                from: "",
                to: ""
            })
        }
    }, [scheduledDate.from, scheduledDate.to])

    useEffect(() => {
        if (joinedDate.from || joinedDate.to) {
            setActiveIndex("")
            setFromDate("")
            setToDate("")
            setScheduledDate({
                from: '', to: ''
            })
            setSubmittedOn({
                from: "",
                to: ""
            })
        }
    }, [joinedDate.from, joinedDate.to])


    useEffect(() => {
        if (submittedOn.from || submittedOn.to) {
            setActiveIndex("")
            setFromDate("")
            setToDate("")
            setScheduledDate({
                from: '', to: ''
            })
            setJoinedDate({
                from: "",
                to: ""
            })
        }
    }, [submittedOn.from, submittedOn.to])


    // reset page to 1 when any filter changes
    useEffect(() => {
        setCurrentPage(1)
    }, [clientId, managerId, teamleadId, recruiterId, updatedByRecruiterId, sanSpocId, clientManager, jobName, candidateName, mobileNumber, emailId, jobStatus, statusId, fromDate, toDate, activeIndex, scheduledDate.from, scheduledDate.to, joinedDate.from, joinedDate.to,submittedOn.from,submittedOn.to])


    useEffect(() => {

        const companyId = currentUser?.company?.companyId
        console.log("companyId", companyId)
        if (!companyId) return
        if (clientId)
            fetchCompanyClientSpocs(BeURL, showAlert, setAllSpocsList, companyId, clientId)
        else
            fetchCompanySpocs(BeURL, showAlert, setAllSpocsList, companyId)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientId])

    //Download requirements using date range

    const handleDownLoadExcel = () => {
        // setActiveIndex("")
        // setFromDate('')
        // setToDate('')
        fetchRecruitmentTableFilter({
            BeURL,
            setRequirement,
            showAlert,
            fromDate,
            toDate,
            type: 'excel',
            currentUser,
            clientId,
            managerId,
            teamleadId,
            recruiterId,
            updatedByRecruiterId,
            sanSpocId,
            clientManager,
            jobName,
            candidateName,
            mobileNumber, emailId,
            jobStatus,
submittedOn,
            statusId,
            scheduledDate,
            joinedDate, setLoading

        })
    }

    // Get the profile history

    const handleHistory = async (candidateId, jobId) => {
        await fetchProfile(BeURL, showAlert, setProfileHistory, jobId, candidateId)
    }

    // Access control for Edit Profile Submission button 

    useEffect(() => {
        const fetchJobs = async () => {
            const map = {};

            for (const report of requirement) {
                const res = await apiFetch(`${BeURL}/fetch-job/${report.job.id}`);
                const data = await res.json();

                if (data.success) {
                    map[report.job.id] = data.job;
                }
            }

            setJob(map);
        };

        if (requirement?.length) {
            fetchJobs();
        }
        // eslint-disable-next-line
    }, [requirement]);

    const getAccess = (report) => {

      
        if (report?.primaryRecruiter?.id === currentUser?._id) return true;
        const currentJob = job[report?.job?.id];
      
        if (currentJob?.reportingTeamLead?.id === currentUser?.id)  return true
        if (report?.reportingManager?.id === currentUser?._id) return true;
        if (report?.profileSubmittedBy?.id === currentUser?._id) return true;
        if (['admin'].includes(currentUser?.role)) return true;
        return false;
    }

    const handleProfileAction = (candidateId, jobId) => {
        // console.log("Job Candidate", candidateId, jobId);

        setSelectedData({ candidateId, jobId });
        setShowSubmission(true);
    };


    console.log("CTC", requirement)
    if (loading) return <div><Loading /></div>;

    return (
        <div className='min-h-[80vh] space-y-4 mt-3 mb-3 '>
            <div className='my-3'>
                <h2 className="text-2xl font-semibold  text-gray-800 text-center"> Recruitment Table Filter Reports</h2>
                <p className='text-gray-500 text-center text-sm pb-2'>Candidate's status updates as separate rows, showing all actions taken throughout the day.</p>

            </div>

            {/* Filter & Date Range */}
            <div className='bg-gradient-to-br from-white to-slate-50/50 rounded-2xl shadow-lg border border-slate-200/60 p-4 mb-6'>
                <div className='flex flex-col gap-3'>

                    {/* Time Filter Buttons & Date Range */}
                    <div className="space-y-3 ">
                        {/* Quick Filter Buttons */}
                        <div className='flex items-center gap-2 flex-wrap'>
                            <div className='flex items-center gap-1.5'>
                                <div className='w-1 h-5 bg-gradient-to-b from-primary-400 to-primary-600 rounded-full'></div>
                                <h3 className='text-xs font-bold text-slate-700 uppercase tracking-wide'> Status Change Quick Filters </h3>
                            </div>
                            <div className="flex gap-2 flex-wrap">
                                {filterButton.map((btn, i) => (
                                    <button
                                        key={i}
                                        title={btn.title}
                                        className={`relative px-3 py-1.5 font-semibold text-xs rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-md
                                     ${activeIndex === btn.label
                                                ? "bg-gradient-to-r from-primary-400 to-primary-600 text-white shadow-lg shadow-primary-200/50 scale-105"
                                                : "bg-white text-primary-500 border-[1px] border-primary-100 hover:border-primary-400 hover:bg-secondary-700"
                                            }
                                        ${activeIndex === btn.label ? 'ring-[1px] ring-primary-200 ring-offset-1' : ''}`}
                                        onClick={() => handleRequirement(btn.label)}
                                    >
                                        {activeIndex === btn.label && (
                                            <span className="absolute -top-0.5 -right-0.5 flex h-2 w-2">
                                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                                                <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
                                            </span>
                                        )}
                                        {btn.label}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Date Range Picker */}
                        {/* <div className='flex items-center gap-2 flex-wrap'>
                            <div className='flex items-center gap-1.5'>
                                <div className='w-1 h-5 bg-gradient-to-b from-blue-400 to-blue-600 rounded-full'></div>
                                <h3 className='text-xs font-bold text-slate-700 uppercase tracking-wide'>Custom Range</h3>
                            </div>
                            <div className='flex gap-2 items-center flex-wrap'>
                                <div className='group relative'>
                                    <label className='text-xs font-semibold text-slate-600 mb-0.5 block'>From Date</label>
                                    <div className='relative'>
                                        <input
                                            type='date'
                                            value={fromDate}
                                            onChange={(e) => { setFromDate(e.target.value); setCurrentPage(1); }}
                                            className='pl-3 pr-2 py-1.5 border-2 border-slate-200 rounded-lg text-xs font-medium text-slate-700 bg-white hover:border-blue-300 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 transition-all outline-none w-full sm:w-auto'
                                        />
                                        <div className='absolute inset-0 rounded-lg bg-gradient-to-r from-blue-400/0 to-blue-400/0 group-hover:from-blue-400/5 group-hover:to-transparent pointer-events-none transition-all'></div>
                                    </div>
                                </div>
                                <div className='hidden sm:flex items-center pt-5'>
                                    <svg className='w-5 h-5 text-slate-400' fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                    </svg>
                                </div>
                                <div className='group relative'>
                                    <label className='text-xs font-semibold text-slate-600 mb-0.5 block'>To Date</label>
                                    <div className='relative'>
                                        <input
                                            type='date'
                                            value={toDate}
                                            onChange={(e) => { setToDate(e.target.value); setCurrentPage(1); }}
                                            className='pl-3 pr-2 py-1.5 border-2 border-slate-200 rounded-lg text-xs font-medium text-slate-700 bg-white hover:border-blue-300 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 transition-all outline-none w-full sm:w-auto'
                                        />
                                        <div className='absolute inset-0 rounded-lg bg-gradient-to-r from-blue-400/0 to-blue-400/0 group-hover:from-blue-400/5 group-hover:to-transparent pointer-events-none transition-all'></div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>

                    {/* Dropdown Filters Section */}
                    {/* <div>
                        <div className='flex items-center gap-1.5 mb-2'>
                            <div className='w-1 h-5 bg-gradient-to-b from-purple-400 to-purple-600 rounded-full'></div>
                            <h3 className='text-xs font-bold text-slate-700 uppercase tracking-wide'>Advanced Filters</h3>
                        </div>
                        <div className="flex gap-2 flex-wrap items-center">
                            {
                                clientsList.length > 0 && (
                                    <div className='group relative'>
                                        <div className='flex items-center gap-1.5 px-3 py-1.5 my-1 bg-gradient-to-br from-blue-50 to-blue-100/50 border-2 border-blue-200 rounded-lg hover:border-blue-400 hover:shadow-md focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-100 transition-all duration-200'>
                                            <svg className='w-3.5 h-3.5 text-blue-500' fill="currentColor" viewBox="0 0 20 20">
                                                <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                                            </svg>
                                            <label className='text-xs font-bold text-blue-700 whitespace-nowrap uppercase tracking-wide'>Client</label>
                                            <select
                                                value={clientId}
                                                onChange={e => { setClientId(e.target.value); setCurrentPage(1); }}
                                                className='text-xs outline-none cursor-pointer bg-transparent border-none text-slate-700 font-semibold min-w-[100px] pr-1'
                                            >
                                                <option value={""}>All Clients</option>
                                                {
                                                    clientsList.length ?
                                                        clientsList.map((client, i) => (
                                                            <option value={client._id} key={i}>{client.clientName}</option>
                                                        ))
                                                        :
                                                        <option disabled>No clients found</option>
                                                }
                                            </select>
                                        </div>
                                    </div>
                                )
                            }

                            {
                                statusList.length > 0 && (
                                    <div className='group relative'>
                                        <div className='flex items-center gap-1.5 px-3 py-1.5 bg-gradient-to-br from-green-50 to-green-100/50 border-2 border-green-200 rounded-lg hover:border-green-400 hover:shadow-md focus-within:border-green-500 focus-within:ring-2 focus-within:ring-green-100 transition-all duration-200'>
                                            <svg className='w-3.5 h-3.5 text-green-500' fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                                            </svg>
                                            <label className='text-xs font-bold text-green-700 whitespace-nowrap uppercase tracking-wide'>Status</label>
                                            <select
                                                value={statusId}
                                                onChange={e => { setStatusId(e.target.value); setCurrentPage(1); }}
                                                className='text-xs outline-none cursor-pointer bg-transparent border-none text-slate-700 font-semibold min-w-[100px] pr-1'
                                            >
                                                <option value={""}>All Status</option>
                                                {
                                                    statusList.length ?
                                                        statusList.map((status, i) => (
                                                            <option value={status._id} key={i}>{formatNames(status?.status || "NA")}</option>
                                                        ))
                                                        :
                                                        <option disabled>No statuses found</option>
                                                }
                                            </select>
                                        </div>
                                    </div>
                                )
                            }

                            {currentUser.role === 'admin' && managersList.length > 0 && (
                                <div className='group relative'>
                                    <div className='flex items-center gap-1.5 px-3 py-1.5 bg-gradient-to-br from-orange-50 to-orange-100/50 border-2 border-orange-200 rounded-lg hover:border-orange-400 hover:shadow-md focus-within:border-orange-500 focus-within:ring-2 focus-within:ring-orange-100 transition-all duration-200'>
                                        <svg className='w-3.5 h-3.5 text-orange-500' fill="currentColor" viewBox="0 0 20 20">
                                            <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
                                        </svg>
                                        <label className='text-xs font-bold text-orange-700 whitespace-nowrap uppercase tracking-wide'>Manager</label>
                                        <select
                                            value={managerId}
                                            onChange={e => { setManagerId(e.target.value); setTeamleadId(''); setRecruiterId(''); setCurrentPage(1); }}
                                            className='text-xs outline-none cursor-pointer bg-transparent border-none text-slate-700 font-semibold min-w-[100px] pr-1'
                                        >
                                            <option value={""}>All Managers</option>
                                            {
                                                managersList.length ?
                                                    managersList.map((manager, i) => (
                                                        <option value={manager.id} key={i}>{renderCapitalize(manager.fullName)}</option>
                                                    ))
                                                    :
                                                    <option disabled>No managers found</option>
                                            }
                                        </select>
                                    </div>
                                </div>)
                            }


                            {['admin', 'manager'].includes(currentUser.role) && (
                                <div className='group relative'>
                                    <div className={`flex items-center gap-1.5 px-3 py-1.5 bg-gradient-to-br from-purple-50 to-purple-100/50 border-2 border-purple-200 rounded-lg hover:border-purple-400 hover:shadow-md focus-within:border-purple-500 focus-within:ring-2 focus-within:ring-purple-100 transition-all duration-200
                                            ${teamleadsList.length === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                        <svg className='w-3.5 h-3.5 text-purple-500' fill="currentColor" viewBox="0 0 20 20">
                                            <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                                        </svg>
                                        <label className='text-xs font-bold text-purple-700 whitespace-nowrap uppercase tracking-wide'>Teamlead</label>
                                        <select
                                            value={teamleadId}
                                            onChange={e => { setTeamleadId(e.target.value); setRecruiterId(''); setCurrentPage(1); }}
                                            className={`text-xs outline-none cursor-pointer bg-transparent border-none text-slate-700 font-semibold min-w-[100px] pr-1 ${teamleadsList.length === 0 ? 'pointer-events-none' : ''}`}
                                        >
                                            <option value={""}>All Teamleads</option>
                                            {
                                                teamleadsList.length ?
                                                    teamleadsList.map((teamlead, i) => (
                                                        <option value={teamlead.id} key={i}>{renderCapitalize(teamlead.fullName)}</option>
                                                    ))
                                                    :
                                                    <option disabled>No teamleads found</option>
                                            }
                                        </select>
                                    </div>
                                </div>
                            )
                            }

                           
                            {['admin', 'manager', 'teamlead'].includes(currentUser.role) && (
                                <div className='group relative'>
                                    <div className={`flex items-center gap-1.5 px-3 py-1.5 bg-gradient-to-br from-pink-50 to-pink-100/50 border-2 border-pink-200 rounded-lg hover:border-pink-400 hover:shadow-md focus-within:border-pink-500 focus-within:ring-2 focus-within:ring-pink-100 transition-all duration-200
                                            ${(recruitersList.length === 0 || (currentUser.role !== 'teamlead' && teamleadsList.length === 0)) ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                        <svg className='w-3.5 h-3.5 text-pink-500' fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                                        </svg>
                                        <label className='text-xs font-bold text-pink-700 whitespace-nowrap uppercase tracking-wide'>Recruiter</label>
                                        <select
                                            value={recruiterId}
                                            onChange={e => { setRecruiterId(e.target.value); setCurrentPage(1); }}
                                            className={`text-xs outline-none cursor-pointer bg-transparent border-none text-slate-700 font-semibold min-w-[100px] pr-1
                                                 ${(recruitersList.length === 0 || (currentUser.role !== 'teamlead' && teamleadsList.length === 0)) ? 'pointer-events-none' : ''}`}
                                        >
                                            <option value={""}>All Recruiters</option>
                                            {
                                                recruitersList.length ?
                                                    recruitersList.map((recruiter, i) => (
                                                        <option value={recruiter.id} key={i}>{renderCapitalize(recruiter.fullName)}</option>
                                                    ))
                                                    :
                                                    <option disabled>No recruiters found</option>
                                            }
                                        </select>
                                    </div>
                                </div>
                            )}

                        </div>

                    </div> */}
                </div>

                {/* Action Buttons */}
                <div className='flex items-center justify-end gap-2 pt-3 mt-1 border-t border-slate-200'>
                    <button
                        className='group flex items-center gap-1.5 px-4 py-2 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white rounded-lg font-bold text-xs shadow-lg shadow-green-200 hover:shadow-xl hover:shadow-green-300 transform hover:scale-105 transition-all duration-200 active:scale-95'
                        onClick={handleDownLoadExcel}
                    >
                        <RiFileExcel2Fill className='text-base group-hover:animate-bounce' />
                        <span>Download Excel</span>
                    </button>

                    <button
                        onClick={() => {
                            // Clear all filters and reset page
                            setClientId("");
                            setStatusId([]);
                            setFromDate('');
                            setToDate('');
                            setTeamleadId('');
                            setRecruiterId('');
                            if (currentUser.role === 'admin') { setManagerId('') }
                            // Default to 'All' quick filter
                            setActiveIndex('All');
                            setCurrentPage(1);
                            setScheduledDate({
                                from: '', to: ''
                            })
                            setSubmittedOn({
                                from: '', to: ''
                            })
                            setJoinedDate({
                                from: '', to: ''
                            })
                            // setShowJoinedDateFilter(false)
                            setShowScheduledDateFilter(false)
                            setClientManager("")
                            setJobStatus("")
                            setShowTeamManagerFillter(false)
                            setShowUpdatedByFilter(false)
                            setJobStatusFilter(false)
                            setSanSpocFilter(false)
                            setShowClientFilter(false)
                            setShowClientSpocFilter(false)
setEmailId('') 
setMobileNumber('')
setJobName('')
setJobStatus('') 
setCandidateName('')

                        }}
                        className='group flex items-center gap-1.5 px-4 py-2 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white rounded-lg font-bold text-xs shadow-lg shadow-red-200 hover:shadow-xl hover:shadow-red-300 transform hover:scale-105 transition-all duration-200 active:scale-95'
                        title='Clear all filters'
                    >
                        <AiOutlineClear className='text-sm group-hover:rotate-180 transition-transform duration-300' />
                        <span>Clear All</span>
                    </button>
                </div>
            </div>

            {/* Table */}
            <div className="overflow-hidden bg-gradient-to-br from-white to-slate-50/50 rounded-2xl shadow-xl border border-slate-200/60">
                {(!requirement || loading) ? (
                    // Loading skeleton
                    <div className="overflow-x-auto scrollbar-thin scrollbar-thumb-primary-300 scrollbar-track-slate-100">
                        <table className="min-w-full border-collapse">
                            <thead className="bg-gradient-to-r from-primary-500 via-primary-600 to-blue-600 text-white sticky top-0 z-10 shadow-lg">
                                <tr>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">S.No</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Team Manager</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Team Lead</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Submitted By</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Updated By</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">SAN SPOC</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Client Name</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Client Manager</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Job Applied</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Applicant Name</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Mobile Number</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Email Address</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Submitted On</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Status Changed On</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Profile Recent Status</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Current CTC</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Expected CTC</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Offered CTC</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Job Status</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Remarks</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Sub category</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Interview ScheduledDate</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider relative">
                                        <button
                                            type="button"
                                            className="inline-flex items-center gap-1"
                                            onClick={() => setShowScheduledDateFilter((prev) => !prev)}
                                        >
                                            ScheduledDate
                                            <span className="text-[10px]">▼</span>
                                        </button>

                                        {showScheduledDateFilter && (
                                            <div className="absolute top-full right-0 mt-2 w-56 bg-white text-slate-700 rounded-lg shadow-xl border border-slate-200 p-3 z-20 normal-case">
                                                <label className="block text-[11px] font-semibold mb-1 text-left">From Date</label>
                                                <input
                                                    type="date"
                                                    value={scheduledDate.from}
                                                    onChange={(e) =>
                                                        setScheduledDate((prev) => ({ ...prev, from: e.target.value }))
                                                    }
                                                    className="w-full mb-2 px-2 py-1 border rounded text-xs"
                                                />

                                                <label className="block text-[11px] font-semibold mb-1 text-left">To Date</label>
                                                <input
                                                    type="date"
                                                    value={scheduledDate.to}
                                                    onChange={(e) =>
                                                        setScheduledDate((prev) => ({ ...prev, to: e.target.value }))
                                                    }
                                                    className="w-full mb-3 px-2 py-1 border rounded text-xs"
                                                />

                                                <div className="flex justify-between">
                                                    <button
                                                        type="button"
                                                        className="text-xs px-2 py-1 rounded bg-slate-100 hover:bg-slate-200"
                                                        onClick={() => {
                                                            setScheduledDate({ from: '', to: '' });
                                                        }}
                                                    >
                                                        Clear
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="text-xs px-2 py-1 rounded bg-primary-500 text-white hover:bg-primary-600"
                                                        onClick={() => setShowScheduledDateFilter(false)}
                                                    >
                                                        Done
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Date of Joining</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Employee Id</th>
                                    <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Update Status</th>

                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-slate-100">
                                {Array.from({ length: rowsPerPage }).map((_, i) => (
                                    <tr key={i} className="border-b border-slate-100">
                                        {Array.from({ length: 22 }).map((_, j) => (
                                            <td key={j} className="p-3 whitespace-nowrap border text-center">
                                                <div className="h-4 bg-gradient-to-r from-slate-200 via-slate-100 to-slate-200 rounded animate-pulse"></div>
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )

                    :
                    (
                        <div className="overflow-x-auto overflow-y-visible min-h-[400px] scrollbar-thin scrollbar-thumb-primary-300 scrollbar-track-slate-100">
                            <table className="min-w-full   border-collapse">
                                <thead className="bg-gradient-to-r from-primary-500 via-primary-600 to-blue-600 text-white sticky top-0 z-10 shadow-lg">
                                    <tr>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">S.No</th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider relative">

                                            {/* Header Button */}
                                            <button
                                                type="button"
                                                className="inline-flex items-center gap-1 uppercase"
                                                onClick={() => setShowTeamManagerFillter(prev => !prev)}
                                            >
                                                Team Manager
                                                <span className={`text-[10px] ${currentUser.role === 'admin' ? 'block' : 'hidden'} `}>▼</span>
                                            </button>
                                            {/* Selected Value */}
                                            {currentUser.role === 'admin' && <p className=" w-44 bg-white px-3 py-1 mt-2 text-sm rounded-md border border-gray-300 text-primary-400
                                          focus:outline-none focus:ring-1 focus:ring-primary-400 
                                          placeholder-gray-400">
                                                {managerId
                                                    ? renderCapitalize(
                                                        managersList.find(m => m.id === managerId)?.fullName || ""
                                                    )
                                                    : "All"}
                                            </p>}

                                            {/* Dropdown */}
                                            {showTeamManagerFilter && currentUser.role === 'admin' && (
                                                <div className="absolute top-full -right-3 mt-2 w-44 bg-white text-slate-700 rounded-xl shadow-2xl border border-slate-200 p-1 z-50">

                                                    <div className="max-h-48 overflow-y-auto">

                                                        {/* All Managers */}
                                                        <div
                                                            className="px-3 py-2 text-xs cursor-pointer hover:bg-orange-100 rounded font-medium"
                                                            onClick={() => {
                                                                setManagerId("")
                                                                setTeamleadId("")
                                                                setRecruiterId("")
                                                                setUpdatedByRecruiterId("")
                                                                setSanSpocId("")
                                                                setCurrentPage(1)
                                                                setShowTeamManagerFillter(false)
                                                            }}
                                                        >
                                                            All Managers
                                                        </div>

                                                        {/* Manager List */}
                                                        {managersList.map((manager) => (
                                                            <div
                                                                key={manager.id}
                                                                className={`px-3 py-2 text-xs cursor-pointer rounded hover:bg-orange-100 ${managerId === manager.id ? "bg-orange-200 font-semibold" : ""
                                                                    }`}
                                                                onClick={() => {
                                                                    setManagerId(manager.id)
                                                                    setTeamleadId("")
                                                                    setRecruiterId("")
                                                                    setUpdatedByRecruiterId("")
                                                                    setSanSpocId("")
                                                                    setCurrentPage(1)
                                                                    setShowTeamManagerFillter(false)
                                                                }}
                                                            >
                                                                {renderCapitalize(manager.fullName)}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider relative">

                                            {/* Header Button */}
                                            <button
                                                type="button"
                                                className="inline-flex items-center gap-1 uppercase"
                                                onClick={() => setTeamLeadFilter(prev => !prev)}
                                            >
                                                Team Lead
                                                <span className={`${['admin', 'manager'].includes(currentUser.role) ? 'block' : 'hidden'} text-[10px]`}>▼</span>
                                            </button>

                                            {['admin', 'manager'].includes(currentUser.role) && <p className="w-44 bg-white px-2 py-1 mt-2 text-sm rounded-md border border-gray-300 text-primary-400
                 focus:outline-none focus:ring-1 focus:ring-primary-400 
                 placeholder-gray-400">
                                                {teamleadId
                                                    ? renderCapitalize(
                                                        teamleadsList.find(m => m.id === teamleadId)?.fullName || ""
                                                    )
                                                    : "All"}
                                            </p>}

                                            {/* Dropdown */}
                                            {showTeamLeadFilter && ['admin', 'manager'].includes(currentUser.role) && (
                                                <div className="absolute top-full right-0 mt-2 w-44 bg-white text-slate-700 rounded-xl shadow-2xl border border-slate-200 p-1 z-50">

                                                    <div className="max-h-48 overflow-y-auto">

                                                        {/* All TeamLeads */}
                                                        <div
                                                            className="px-3 py-2 text-xs cursor-pointer hover:bg-purple-100 rounded font-medium"
                                                            onClick={() => {
                                                                setTeamleadId("")
                                                                setRecruiterId("")
                                                                setUpdatedByRecruiterId("")
                                                                setSanSpocId("")
                                                                setCurrentPage(1)
                                                                setTeamLeadFilter(false)
                                                            }}
                                                        >
                                                            All TeamLeads
                                                        </div>

                                                        {/* TeamLead List */}
                                                        {teamleadsList.length > 0 ? (
                                                            teamleadsList.map((teamlead) => (
                                                                <div
                                                                    key={teamlead.id}
                                                                    className={`px-3 py-2 text-xs cursor-pointer rounded hover:${teamlead.isEmployee === false ? 'bg-red-500' :'bg-purple-100'} ${teamleadId === teamlead.id ? "bg-purple-200 font-semibold" : ""
                                                                        } ${teamlead.isEmployee === false && 'bg-red-500'}`}
                                                                    onClick={() => {
                                                                        setTeamleadId(teamlead.id)
                                                                        setRecruiterId("")
                                                                        setUpdatedByRecruiterId("")
                                                                        setSanSpocId("")
                                                                        setCurrentPage(1)
                                                                        setTeamLeadFilter(false)
                                                                    }}
                                                                >
                                                                    {renderCapitalize(teamlead.fullName)}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="px-3 py-2 text-xs text-gray-400">
                                                                No teamleads found
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider relative">

                                            {/* Header Button */}
                                            <button
                                                type="button"
                                                className="inline-flex items-center gap-1 uppercase"
                                                onClick={() => {
                                                    setShowSubmittedByFilter(prev => !prev)
                                                    setShowUpdatedByFilter(false)
                                                    setSanSpocFilter(false)
                                                }}
                                            >
                                                Submitted By
                                                <span className={`${['admin', 'manager', 'teamlead'].includes(currentUser.role) ? 'block' : 'hidden'} text-[10px]`}>▼</span>
                                            </button>

                                            {['admin', 'manager', 'teamlead'].includes(currentUser.role) && <p className="bg-white px-2 py-1 mt-2 text-sm rounded-md border border-gray-300 text-primary-400 w-44
                 focus:outline-none focus:ring-1 focus:ring-primary-400 
                 placeholder-gray-400">
                                                {recruiterId
                                                    ? renderCapitalize(
                                                        recruitersList.find(m => m.id === recruiterId)?.fullName || ""
                                                    )
                                                    : "All"}
                                            </p>}

                                            {/* Recruiter Filter */}
                                            {showSubmittedByFilter && ['admin', 'manager', 'teamlead'].includes(currentUser.role) && (
                                                <div className="absolute top-full -right-10 mt-2 w-40 bg-white text-slate-700 rounded-xl shadow-2xl border border-slate-200 p-1 z-50">

                                                    <div className="max-h-48 overflow-y-auto">

                                                        {/* All Recruiters */}
                                                        <div
                                                            className="px-3 py-2 text-xs cursor-pointer hover:bg-pink-100 rounded font-medium"
                                                            onClick={() => {
                                                                setRecruiterId("")
                                                                setCurrentPage(1)
                                                                setShowSubmittedByFilter(false)
                                                            }}
                                                        >
                                                            All Recruiters
                                                        </div>

                                                        {/* Recruiter List */}
                                                        {(recruitersList.length > 0 &&
                                                            (currentUser.role === 'teamlead' || teamleadsList.length > 0)) ? (
                                                            recruitersList.map((recruiter) => (
                                                                <div
                                                                    key={recruiter.id}
                                                                    className={`px-3 py-2 text-xs cursor-pointer rounded hover:${recruiter.isEmployee === false ? 'bg-red-500' :'bg-pink-100'} ${recruiterId === recruiter.id ? "bg-pink-200 font-semibold" : ""
                                                                        }  ${recruiter.isEmployee === false && 'bg-red-500'}`}
                                                                    onClick={() => {
                                                                        setRecruiterId(recruiter.id)
                                                                        setCurrentPage(1)
                                                                        setUpdatedByRecruiterId("")
                                                                        setShowSubmittedByFilter(false)
                                                                    }}
                                                                >
                                                                    {renderCapitalize(recruiter.fullName)}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="px-3 py-2 text-xs text-gray-400">
                                                                No recruiters found
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider relative">

                                            {/* Header Button */}
                                            <button
                                                type="button"
                                                className="inline-flex items-center gap-1 uppercase"
                                                onClick={() => {
                                                    setShowUpdatedByFilter(prev => !prev)
                                                    setShowSubmittedByFilter(false)
                                                    setSanSpocFilter(false)
                                                }}
                                            >
                                                Updated By
                                                <span className={`${['admin', 'manager', 'teamlead'].includes(currentUser.role) ? 'block' : 'hidden'} text-[10px]`}>▼</span>
                                            </button>

                                            {['admin', 'manager', 'teamlead'].includes(currentUser.role) && <p className="w-44 bg-white px-2 py-1 mt-2 text-sm rounded-md border border-gray-300 text-primary-400
                 focus:outline-none focus:ring-1 focus:ring-primary-400 
                 placeholder-gray-400">
                                                {updatedByRecruiterId
                                                    ? renderCapitalize(
                                                        recruitersList.find(m => m.id === updatedByRecruiterId)?.fullName || ""
                                                    )
                                                    : "All"}
                                            </p>}
                                            {/* Recruiter Filter */}
                                            {showUpdatedByFilter && ['admin', 'manager', 'teamlead'].includes(currentUser.role) && (
                                                <div className="absolute top-full -right-10 mt-2 w-40 bg-white text-slate-700 rounded-xl shadow-2xl border border-slate-200 p-1 z-50">

                                                    <div className="max-h-48 overflow-y-auto">

                                                        {/* All Recruiters */}
                                                        <div
                                                            className="px-3 py-2 text-xs cursor-pointer hover:bg-teal-100 rounded font-medium"
                                                            onClick={() => {
                                                                setUpdatedByRecruiterId("")
                                                                setCurrentPage(1)
                                                                setShowUpdatedByFilter(false)
                                                            }}
                                                        >
                                                            All Recruiters
                                                        </div>

                                                        {/* Recruiter List */}
                                                        {(recruitersList.length > 0 &&
                                                            (currentUser.role === 'teamlead' || teamleadsList.length > 0)) ? (
                                                            recruitersList.map((recruiter) => (
                                                                <div
                                                                    key={recruiter.id}
                                                                    className={`px-3 py-2 text-xs cursor-pointer rounded hover:${recruiter.isEmployee === false ? 'bg-red-500' :'bg-teal-100'} ${updatedByRecruiterId === recruiter.id ? "bg-teal-200 font-semibold" : ""
                                                                        }  ${recruiter.isEmployee === false && 'bg-red-500'}`}
                                                                    onClick={() => {
                                                                        setUpdatedByRecruiterId(recruiter.id)
                                                                        setRecruiterId("")
                                                                        setCurrentPage(1)
                                                                        setShowUpdatedByFilter(false)
                                                                    }}
                                                                >
                                                                    {renderCapitalize(recruiter.fullName)}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="px-3 py-2 text-xs text-gray-400">
                                                                No recruiters found
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider relative">

                                            {/* Header Button */}
                                            <button
                                                type="button"
                                                className="inline-flex items-center gap-1 uppercase"
                                                onClick={() => {
                                                    setSanSpocFilter(prev => !prev)
                                                    setShowSubmittedByFilter(false)
                                                    setShowUpdatedByFilter(false)
                                                }}
                                            > SAN spoc
                                                <span className={`${['admin', 'manager', 'teamlead'].includes(currentUser.role) ? 'block' : 'hidden'} text-[10px]`}>▼</span>
                                            </button>

                                            {['admin', 'manager', 'teamlead'].includes(currentUser.role) && <p className="w-44 bg-white px-2 py-1 mt-2 text-sm rounded-md border border-gray-300 text-primary-400
                 focus:outline-none focus:ring-1 focus:ring-primary-400 
                 placeholder-gray-400">
                                                {sanSpocId
                                                    ? renderCapitalize(
                                                        recruitersList.find(m => m.id === sanSpocId)?.fullName || ""
                                                    )
                                                    : "All"}
                                            </p>}

                                            {/* Recruiter Filter */}
                                            {showSanSpocFilter && ['admin', 'manager', 'teamlead'].includes(currentUser.role) && (
                                                <div className="absolute top-full -right-10 mt-2 w-40 bg-white text-slate-700 rounded-xl shadow-2xl border border-slate-200 p-1 z-50">

                                                    <div className="max-h-48 overflow-y-auto">

                                                        {/* All Recruiters */}
                                                        <div
                                                            className="px-3 py-2 text-xs cursor-pointer hover:bg-red-100 rounded font-medium"
                                                            onClick={() => {
                                                                setSanSpocId("")
                                                                setCurrentPage(1)
                                                                setSanSpocFilter(false)
                                                            }}
                                                        >
                                                            All Recruiters
                                                        </div>

                                                        {/* Recruiter List */}
                                                        {(recruitersList.length > 0 &&
                                                            (currentUser.role === 'teamlead' || teamleadsList.length > 0)) ? (
                                                            recruitersList.map((recruiter) => (
                                                                <div
                                                                    key={recruiter.id}
                                                                    className={`px-3 py-2 text-xs cursor-pointer rounded hover:bg-red-100 ${sanSpocId === recruiter.id ? "bg-red-200 font-semibold" : ""
                                                                        }`}
                                                                    onClick={() => {
                                                                        setSanSpocId(recruiter.id)
                                                                        setCurrentPage(1)
                                                                        setSanSpocFilter(false)
                                                                    }}
                                                                >
                                                                    {renderCapitalize(recruiter.fullName)}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="px-3 py-2 text-xs text-gray-400">
                                                                No recruiters found
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider relative">
                                            <button
                                                type="button"
                                                className="inline-flex items-center gap-1 uppercase"
                                                onClick={() =>
                                                    setShowClientFilter(prev => !prev)
                                                }
                                            >
                                                Client Name
                                                <span className="text-[10px]">▼</span>
                                            </button>
                                            <p className="w-44 bg-white px-2 py-1 mt-2 text-sm rounded-md border border-gray-300 text-primary-400
                 focus:outline-none focus:ring-1 focus:ring-primary-400 
                 placeholder-gray-400">
                                                {clientId
                                                    ? renderCapitalize(
                                                        clientsList.find(m => m._id === clientId)?.clientName || ""
                                                    )
                                                    : "All"}
                                            </p>
                                            {showClientFilter && (
                                                <div className="absolute top-full -right-10 mt-2 w-48 bg-white text-slate-700 rounded-xl shadow-2xl border border-slate-200 p-1 z-50">

                                                    <div className="max-h-48 overflow-y-auto">

                                                        {/* All Clients */}
                                                        <div
                                                            className="px-3 py-2 text-xs cursor-pointer hover:bg-blue-100 rounded font-medium"
                                                            onClick={() => {
                                                                setClientId("")
                                                                setClientManager("")
                                                                setCurrentPage(1)
                                                                setShowClientFilter(false)
                                                            }}
                                                        >
                                                            All Clients
                                                        </div>

                                                        {/* Client List */}
                                                        {clientsList.map((client) => (
                                                            <div
                                                                key={client._id}
                                                                className={`px-3 py-2 text-xs cursor-pointer rounded hover:bg-blue-100 ${clientId === client._id ? "bg-blue-200 font-semibold" : ""
                                                                    }`}
                                                                onClick={() => {
                                                                    setClientId(client._id)
                                                                    setCurrentPage(1)
                                                                    setShowClientFilter(false)
                                                                    setClientManager("")
                                                                }}
                                                            >
                                                                {client.clientName}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider relative">
                                            {/* <FilterSearchReport name={'Client Manager'} values={clientManager} updateState={setClientManager} /> */}
                                            <button
                                                type="button"
                                                className="inline-flex items-center gap-1 uppercase"
                                                onClick={() =>
                                                    setShowClientSpocFilter(prev => !prev)
                                                }
                                            >
                                                Client Manager
                                                <span className="text-[10px]">▼</span>
                                            </button>
                                            <p className="w-44 bg-white px-2 py-1 mt-2 text-sm rounded-md border border-gray-300 text-primary-400
                 focus:outline-none focus:ring-1 focus:ring-primary-400 
                 placeholder-gray-400">
                                                {clientManager
                                                    ? renderCapitalize(
                                                        allSpocsList.find(m => m._id === clientManager)?.fullName || ""
                                                    )
                                                    : "All"}
                                            </p>
                                            {showClientSpocFilter && (
                                                <div className="absolute top-full -right-10 mt-2 w-48 bg-white text-slate-700 rounded-xl shadow-2xl border border-slate-200 p-1 z-50">

                                                    <div className="max-h-48 overflow-y-auto">

                                                        {/* All Clients */}
                                                        <div
                                                            className="px-3 py-2 text-xs cursor-pointer hover:bg-blue-100 rounded font-medium"
                                                            onClick={() => {
                                                                setClientManager("")
                                                                setCurrentPage(1)
                                                                setShowClientSpocFilter(false)
                                                            }}
                                                        >
                                                            All Clients Manager
                                                        </div>

                                                        {/* Client List */}
                                                        {allSpocsList.map((client) => (
                                                            <div
                                                                key={client._id}
                                                                className={`px-3 py-2 text-xs cursor-pointer rounded hover:bg-blue-100 ${clientId === client._id ? "bg-blue-200 font-semibold" : ""
                                                                    }`}
                                                                onClick={() => {
                                                                    setClientManager(client._id)
                                                                    setCurrentPage(1)
                                                                    setShowClientSpocFilter(false)
                                                                }}
                                                            >
                                                                {client.fullName}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </th>
                                        <th className="py-3 px-2 border-r border-primary-400/30 text-center">
                                            <FilterSearchReport name={' Job Applied'} values={jobName} updateState={setJobName} />

                                        </th>
                                        <th className="py-3 px-2 border-r border-primary-400/30 text-center">
                                            <FilterSearchReport name={'Applicant Name'} values={candidateName} updateState={setCandidateName} />
                                        </th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">
                                            <FilterSearchReport name={'Mobile Number'} values={mobileNumber} updateState={setMobileNumber} />
                                        </th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">
                                            <FilterSearchReport name={'Email Address'} values={emailId} updateState={setEmailId} />

                                        </th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider"> <button
                                            type="button"
                                            className="inline-flex items-center gap-1 uppercase"
                                            onClick={() => {
                                                // setShowJoinedDateFilter((prev) => !prev)
                                                setShowScheduledDateFilter(false)
                                                setScheduledDate({
                                                    from: '', to: ''
                                                })
                                                setJoinedDate({
                                                    from: '', to: ''
                                                })
                                                setFromDate('')
                                                setToDate('')

                                            }}
                                        >
                                           Submitted On
                                        </button>

                                            <div className="flex  gap-1 text-gray-600 items-end">
                                                <div>
                                                    <label className="block text-white text-[11px] font-semibold mb-1 text-left">From </label>
                                                    <input
                                                        type="date"
                                                        value={submittedOn.from}
                                                        onChange={(e) => {
                                                            setSubmittedOn((prev) => ({ ...prev, from: e.target.value }))
                                                        }
                                                        }
                                                        className="w-full px-2 py-1 border rounded text-xs"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-white text-[11px] font-semibold mb-1 text-left">To </label>
                                                    <input
                                                        type="date"
                                                        value={submittedOn.to}
                                                        onChange={(e) =>
                                                            setSubmittedOn((prev) => ({ ...prev, to: e.target.value }))
                                                        }
                                                        className="w-full  px-2 py-1 border rounded text-xs"
                                                    />

                                                </div>



                                                <button
                                                    type="button"
                                                    className="text-xs px-2 py-1 rounded bg-slate-100 hover:bg-slate-200"
                                                    onClick={() => {
                                                        setSubmittedOn({ from: '', to: '' });
                                                        // setShowJoinedDateFilter((prev) => !prev)
                                                    }}
                                                >
                                                    Clear
                                                </button>


                                            </div></th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">
                                            <button
                                                type="button"
                                                className="inline-flex items-center gap-1 uppercase"
                                                onClick={() => {
                                                    // setShowJoinedDateFilter((prev) => !prev)
                                                    setShowScheduledDateFilter(false)
                                                    setScheduledDate({
                                                        from: '', to: ''
                                                    })
                                                    setJoinedDate({
                                                        from: '', to: ''
                                                    })
                                                    setSubmittedOn({
                                                        from:'', to:''
                                                    })

                                                }}
                                            >
                                               Status Changed On
                                            </button>

                                            <div className="flex  gap-1 text-gray-600 items-end">
                                                <div>
                                                    <label className="block text-white text-[11px] font-semibold mb-1 text-left">From </label>
                                                    <input
                                                        type="date"
                                                        value={fromDate}
                                                        onChange={(e) => { setFromDate(e.target.value); setCurrentPage(1); }}
                                                        className="w-full px-2 py-1 border rounded text-xs"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-white text-[11px] font-semibold mb-1 text-left">To </label>
                                                    <input
                                                        type="date"
                                                        value={toDate}
                                                        onChange={(e) => { setToDate(e.target.value); setCurrentPage(1); }}
                                                        className="w-full  px-2 py-1 border rounded text-xs"
                                                    />

                                                </div>



                                                <button
                                                    type="button"
                                                    className="text-xs px-2 py-1 rounded bg-slate-100 hover:bg-slate-200"
                                                    onClick={() => {
                                                       setFromDate('')
                                                       setToDate('')
                                                       
                                                        // setShowJoinedDateFilter((prev) => !prev)
                                                    }}
                                                >
                                                    Clear
                                                </button>


                                            </div>
                                          
                                           </th>
                                        {/* <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider"> Status Type</th> */}
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider relative">

                                            {/* Header Button */}
                                            <button
                                                type="button"
                                                className="inline-flex items-center gap-1 uppercase"
                                                onClick={() => setShowStatusFilter(prev => !prev)}
                                            >
                                                Profile Recent Status
                                                <span className="text-[10px]">▼</span>
                                            </button>

                                            {/* Selected Values */}
                                            <p className={`w-full bg-white px-2 py-1 mt-2 text-sm rounded-md border border-gray-300 text-primary-400 ${statusId.length > 0 ? 'lowercase' : 'uppercase'} `}>
                                                {statusId?.length > 0
                                                    ? `${statusId.length} statues selected`
                                                       
                                                    : "All"}
                                            </p>
                                            {/* {console.log("Capitalize :", statusId, statusList)} */}
                                            {/* Dropdown */}
                                            {showStatusFilter && (
                                                <div  className="absolute top-full -right-5 mt-2 w-56 bg-white text-slate-700 rounded-xl shadow-2xl border border-slate-200 p-1 z-50">

                                                    <div className="max-h-48 overflow-y-auto" onMouseLeave={() => setShowStatusFilter(false)}>

                                                        {/* All Status */}
                                                        <div
                                                            className="px-3 py-2 text-xs cursor-pointer hover:bg-green-100 rounded font-medium"
                                                            onClick={() => {
                                                                setStatusId([])
                                                                setCurrentPage(1)
                                                            }}
                                                        >
                                                            All Status
                                                        </div>

                                                        {/* Status List */}
                                                        {statusList.map((status) => {
                                                            const isSelected = statusId.includes(status._id)

                                                            return (
                                                                <div 
                                                                    key={status._id}
                                                                    className={`px-3 py-2 text-xs cursor-pointer rounded hover:bg-green-100 
                            ${isSelected ? "bg-green-200 font-semibold" : ""}`}
                                                                    onClick={() => {
                                                                        setStatusId(prev =>
                                                                            isSelected
                                                                                ? prev.filter(id => id !== status._id) // remove
                                                                                : [...prev, status._id] // add
                                                                        )
                                                                        setCurrentPage(1)
                                                                    }}
                                                                >
                                                                    {formatNames(status?.status || "NA")}
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            )}
                                        </th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Current CTC</th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Expected CTC</th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Offered CTC</th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider relative">
                                            {/* <FilterSearchReport name={'Job Status'} values={jobStatus} updateState={setJobStatus} /> */}
                                            <button
                                                type="button"
                                                className="inline-flex items-center gap-1 uppercase"
                                                onClick={() =>
                                                    setJobStatusFilter(prev => !prev)
                                                }
                                            >
                                                Job Status
                                                <span className="text-[10px]">▼</span>
                                            </button>
                                            <p className= " w-44 bg-white px-2 py-1 mt-2 text-sm rounded-md border border-gray-300 text-primary-400
                                            focus:outline-none focus:ring-1 focus:ring-primary-400 
                                        placeholder-gray-400">
                                                {jobStatus
                                                    ? renderCapitalize(
                                                        jobStatus
                                                    )
                                                    : "All"}
                                            </p>
                                            {showJobStatusFilter && (
                                                <div className="absolute top-full -right-10 mt-2 w-48 bg-white text-slate-700 rounded-xl shadow-2xl border border-slate-200 p-1 z-50">

                                                    <div className="max-h-48 overflow-y-auto">

                                                        {/* All Clients */}
                                                        <div
                                                            className="px-3 py-2 text-xs cursor-pointer hover:bg-blue-100 rounded font-medium"
                                                            onClick={() => {
                                                                setJobStatus("")
                                                                setCurrentPage(1)
                                                                setJobStatusFilter(false)
                                                            }}
                                                        >
                                                            All Job Status
                                                        </div>

                                                        {/* Client List */}
                                                        {['Active', 'Closed'].map((status, i) => (
                                                            <div
                                                                key={i}
                                                                className={`px-3 py-2 text-xs cursor-pointer rounded hover:bg-blue-100 ${status === jobStatus ? "bg-blue-200 font-semibold" : ""
                                                                    }`}
                                                                onClick={() => {
                                                                    setJobStatus(status.toLowerCase())
                                                                    setCurrentPage(1)
                                                                    setJobStatusFilter(false)
                                                                }}
                                                            >
                                                                {status}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Remarks</th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Sub category</th>
                                        {/* <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">ScheduledDate</th> */}
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider relative">
                                            <button
                                                type="button"
                                                className="inline-flex items-center gap-1 uppercase"
                                                onClick={() => {
                                                    setShowScheduledDateFilter((prev) => !prev)
                                                    // setShowJoinedDateFilter(false)

                                                    setJoinedDate({
                                                        from: '', to: ''
                                                    })
                                                    setSubmittedOn({
                                                        from: '', to: ''
                                                    })
                                                }}
                                            >
                                                Interview Scheduled Date
                                            </button>

                                            <div className=" flex gap-1 text-gray-600 items-end">
                                               
                                               <div>
                                                    <label className="block text-white text-[11px] font-semibold mb-1 text-left"> From</label>
                                                    <input
                                                        type="date"
                                                        value={scheduledDate.from}
                                                        onChange={(e) => {
                                                            setScheduledDate((prev) => ({ ...prev, from: e.target.value }))
                                                        }
                                                        }
                                                        className="w-full  px-2 py-1 border rounded text-xs"
                                                    />
                                               </div>

                                               <div>
                                                    <label className="block text-white text-[11px] font-semibold mb-1 text-left">To</label>
                                                    <input
                                                        type="date"
                                                        value={scheduledDate.to}
                                                        onChange={(e) =>
                                                            setScheduledDate((prev) => ({ ...prev, to: e.target.value }))
                                                        }
                                                        className="w-full  px-2 py-1 border rounded text-xs"
                                                    />
                                               </div>



                                     
                                                    <button
                                                        type="button"
                                                        className="text-xs px-2 py-1 rounded bg-slate-100 hover:bg-slate-200"
                                                        onClick={() => {
                                                            setScheduledDate({ from: '', to: '' });
                                                            setShowScheduledDateFilter((prev) => !prev)
                                                        }}
                                                    >
                                                        Clear
                                                    </button>

                                            </div>

                                            {/* {showScheduledDateFilter && (
                                                <div className="absolute top-full right-0 mt-2 w-40 bg-white text-slate-700 rounded-lg shadow-xl border border-slate-200 p-3 z-20 normal-case">
                                                    <label className="block text-[11px] font-semibold mb-1 text-left">From Date</label>
                                                    <input
                                                        type="date"
                                                        value={scheduledDate.from}
                                                        onChange={(e) => {
                                                            setScheduledDate((prev) => ({ ...prev, from: e.target.value }))
                                                        }
                                                        }
                                                        className="w-full mb-2 px-2 py-1 border rounded text-xs"
                                                    />

                                                    <label className="block text-[11px] font-semibold mb-1 text-left">To Date</label>
                                                    <input
                                                        type="date"
                                                        value={scheduledDate.to}
                                                        onChange={(e) =>
                                                            setScheduledDate((prev) => ({ ...prev, to: e.target.value }))
                                                        }
                                                        className="w-full mb-3 px-2 py-1 border rounded text-xs"
                                                    />

                                                    <div className="flex justify-between">
                                                        <button
                                                            type="button"
                                                            className="text-xs px-2 py-1 rounded bg-slate-100 hover:bg-slate-200"
                                                            onClick={() => {
                                                                setScheduledDate({ from: '', to: '' });
                                                                setShowScheduledDateFilter((prev) => !prev)
                                                            }}
                                                        >
                                                            Clear
                                                        </button>

                                                    </div>
                                                </div>
                                            )} */}
                                        </th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider relative">
                                            <button
                                                type="button"
                                                className="inline-flex items-center gap-1 uppercase"
                                                onClick={() => {
                                                    // setShowJoinedDateFilter((prev) => !prev)
                                                    setShowScheduledDateFilter(false)
                                                    setScheduledDate({
                                                        from: '', to: ''
                                                    })
                                                    setSubmittedOn({from:'', to:''})

                                                }}
                                            >
                                                Date Of Joining
                                            </button>

                                            <div className="flex  gap-1 text-gray-600 items-end">
                                                <div>
                                                    <label className="block text-white text-[11px] font-semibold mb-1 text-left">From </label>
                                                    <input
                                                        type="date"
                                                        value={joinedDate.from}
                                                        onChange={(e) => {
                                                            setJoinedDate((prev) => ({ ...prev, from: e.target.value }))
                                                        }
                                                        }
                                                        className="w-full px-2 py-1 border rounded text-xs"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-white text-[11px] font-semibold mb-1 text-left">To </label>
                                                    <input
                                                        type="date"
                                                        value={joinedDate.to}
                                                        onChange={(e) =>
                                                            setJoinedDate((prev) => ({ ...prev, to: e.target.value }))
                                                        }
                                                        className="w-full  px-2 py-1 border rounded text-xs"
                                                    />

                                                </div>


                                           
                                                    <button
                                                        type="button"
                                                        className="text-xs px-2 py-1 rounded bg-slate-100 hover:bg-slate-200"
                                                        onClick={() => {
                                                            setJoinedDate({ from: '', to: '' });
                                                            // setShowJoinedDateFilter((prev) => !prev)
                                                        }}
                                                    >
                                                        Clear
                                                    </button>

                                           
                                            </div>
{/* 
                                            {showJoinedDateFilter && (
                                                <div className="absolute top-full -right-4 mt-2 w-40 bg-white text-slate-700 rounded-lg shadow-xl border border-slate-200 p-3 z-20 normal-case">
                                                    <label className="block text-[11px] font-semibold mb-1 text-left">From Date</label>
                                                    <input
                                                        type="date"
                                                        value={joinedDate.from}
                                                        onChange={(e) => {
                                                            setJoinedDate((prev) => ({ ...prev, from: e.target.value }))
                                                        }
                                                        }
                                                        className="w-full mb-2 px-2 py-1 border rounded text-xs"
                                                    />

                                                    <label className="block text-[11px] font-semibold mb-1 text-left">To Date</label>
                                                    <input
                                                        type="date"
                                                        value={joinedDate.to}
                                                        onChange={(e) =>
                                                            setJoinedDate((prev) => ({ ...prev, to: e.target.value }))
                                                        }
                                                        className="w-full mb-3 px-2 py-1 border rounded text-xs"
                                                    />

                                                    <div className="flex justify-between">
                                                        <button
                                                            type="button"
                                                            className="text-xs px-2 py-1 rounded bg-slate-100 hover:bg-slate-200"
                                                            onClick={() => {
                                                                setJoinedDate({ from: '', to: '' });
                                                                setShowJoinedDateFilter((prev) => !prev)
                                                            }}
                                                        >
                                                            Clear
                                                        </button>

                                                    </div>
                                                </div>
                                            )} */}
                                        </th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Employee Id</th>
                                        <th className="p-3 whitespace-nowrap border-r border-primary-400/30 text-center font-bold text-xs uppercase tracking-wider">Update Status</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-slate-100">
                                    {loading ? (
                                        <tr>
                                            <td colSpan={20} className="text-center py-10">
                                                <Loading />
                                            </td>
                                        </tr>
                                    ) : Array.isArray(requirement) && requirement.length > 0 ? (
                                        requirement?.map((r, i) => (
                                            <tr key={i} className="hover:bg-blue-50 border-b border-slate-100">
                                                <td className="p-3 whitespace-nowrap border text-center ">{(currentPage - 1) * rowsPerPage + (i + 1)}</td>
                                                <td className="p-3 whitespace-nowrap border text-center   cursor-pointer">{renderCapitalize(r?.reportingManager?.name || '-')}</td>
                                                <td className="p-3 whitespace-nowrap border text-center   cursor-pointer">{renderCapitalize(r?.reportingTeamLead?.name || '-')}</td>
                                                <td className="p-3 whitespace-nowrap border text-center   cursor-pointer">{renderCapitalize(r?.profileSubmittedBy?.name || '-')}</td>
                                                <td className="p-3 whitespace-nowrap border text-center   cursor-pointer">{renderCapitalize(r?.submittedBy?.name || '-')}</td>
                                                <td className="p-3 whitespace-nowrap border text-center   cursor-pointer">{renderCapitalize(r?.primaryRecruiter?.name || '-')}</td>
                                                <td className="p-3 whitespace-nowrap border text-center   cursor-pointer">{r?.client?.name ?? '-'}</td>
                                                <td className="p-3 whitespace-nowrap border text-center   cursor-pointer">{renderCapitalize(r?.spoc?.name || '-')}</td>
                                                <td className="p-3 whitespace-nowrap border text-center   cursor-pointer">{renderCapitalize(r?.job?.title || '-')}</td>
                                                <td className="p-3 whitespace-nowrap border text-center   cursor-pointer">{renderCapitalize(r?.candidate?.name || '-')}</td>
                                                <td className="p-3 whitespace-nowrap border text-center   cursor-pointer">{r?.candidate?.number ?? '-'}</td>
                                                <td className="p-3 whitespace-nowrap border text-center   cursor-pointer">{r?.candidate?.email ?? '-'}</td>
                                                <td className="p-3 whitespace-nowrap border text-center   cursor-pointer">{r?.profileSubmittedOn && !isNaN(new Date(r?.profileSubmittedOn)) ? new Date(r?.profileSubmittedOn).toLocaleString("en-GB") : "-"}</td>
                                                <td className="p-3 whitespace-nowrap border text-center   cursor-pointer">{r?.recentStatus?.timestamp && !isNaN(new Date(r?.recentStatus?.timestamp)) ? new Date(r?.recentStatus?.timestamp).toLocaleString("en-GB") : "-"}</td>
                                                {/* <td className="p-3 whitespace-nowrap border text-center   cursor-pointer">{r?.statusType ?? '-'}</td> */}
                                                <td className="p-3 whitespace-nowrap border text-center cursor-pointer">
                                                    <div className='gap-2 flex items-center justify-between'>
                                                        <BiHistory
                                                            className="text-secondary-400 text-xl cursor-pointer"
                                                            title="View History"
                                                            onClick={() => handleHistory(r?.candidate.id, r.job.id)}
                                                        />
                                                        {(r?.recentStatus?.status) ? formatNames(r.recentStatus.status) : '-'}
                                                    </div>
                                                </td>
                                                <td className="p-3 whitespace-nowrap border-r border-slate-100 text-center text-sm text-slate-700 cursor-pointer">{r?.currentCTC?.amount ?? '-'}</td>
                                                <td className="p-3 whitespace-nowrap border-r border-slate-100 text-center text-sm text-slate-700 cursor-pointer">{r?.expectedCTC?.amount ?? '-'}</td>
                                                <td className="p-3 whitespace-nowrap border-r border-slate-100 text-center text-sm text-slate-700 cursor-pointer">{r?.recentStatus?.offeredCtc ?? '-'}</td>
                                                <td className="p-3 whitespace-nowrap border-r border-slate-100 text-center text-sm text-slate-700 cursor-pointer">{(r?.job?.status) ? formatNames(r?.job?.status) : '-'}</td>

                                                <td className="p-3 whitespace-nowrap border-r border-slate-100 text-center text-sm text-slate-700 cursor-pointer">{r?.recentStatus?.comment ?? '-'}</td>
                                                <td className="p-3 whitespace-nowrap border-r border-slate-100 text-center text-sm text-slate-700 cursor-pointer">{r?.recentStatus?.subcategory ?? '-'}</td>
                                                <td className="p-3 whitespace-nowrap border-r border-slate-100 text-center text-sm text-slate-700 cursor-pointer">{r?.recentStatus?.scheduledDate && !isNaN(new Date(r.recentStatus?.scheduledDate)) ? new Date(r.recentStatus?.scheduledDate).toLocaleString("en-GB") : "-"}</td>
                                                <td className="p-3 whitespace-nowrap border-r border-slate-100 text-center text-sm text-slate-700 cursor-pointer">{r?.recentStatus?.doj
                                                    ? new Date(r?.recentStatus?.doj).toLocaleDateString("en-GB")
                                                    : "-"}</td>
                                                    {console.log("Reports are :", r)}
                                                <td className="p-3 whitespace-nowrap border-r border-slate-100 text-center text-sm text-slate-700 cursor-pointer">{r?.job?.empId ?? '-'}</td>
                                                <td className={`p-3 whitespace-nowrap border-r border-slate-100 text-center text-sm text-slate-700 cursor-pointer`}>

                                                 {console.log(getAccess(r))}
                                                    <button
                                                        disabled={!getAccess(r)}
                                                        className={`border font-medium rounded-lg px-2 py-1 transition shadow-lg
                                                     ${getAccess(r) ? 'text-primary-400 cursor-pointer hover:bg-primary-200 hover:text-white' :
                                                                'cursor-not-allowed text-gray-300'
                                                            }
                                                         `}
                                                        onClick={() => handleProfileAction(r.candidate.id, r.job.id)}
                                                    >
                                                        Update Status
                                                    </button>


                                                    {/* <button
                                                        // disabled={!getAccess(r)}
                                                        className={`border font-medium rounded-lg px-2 py-1 transition shadow-lg
                                                   text-primary-400 cursor-pointer hover:bg-primary-200 hover:text-white `}
                                                        onClick={() => handleProfileAction(r.candidate.id, r.job.id)}
                                                    >
                                                        Update Status
                                                    </button> */}

                                                </td>
                                            </tr>
                                        ))) : (
                                        <tr>
                                            <td colSpan={20}>
                                                <div className="py-16 px-8">
                                                    <div className="flex flex-col items-center justify-center space-y-4">
                                                        <div className="relative">
                                                            <div className="w-24 h-24 bg-gradient-to-br from-slate-100 to-slate-200 rounded-full flex items-center justify-center">
                                                                <svg className="w-12 h-12 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                                </svg>
                                                            </div>
                                                            <div className="absolute -top-1 -right-1 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center">
                                                                <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                        <div className="text-center space-y-2">
                                                            <h3 className="text-xl font-bold text-slate-700">No Data Found</h3>
                                                            <p className="text-sm text-slate-500 max-w-md mx-auto">
                                                                There are no recruitment records matching your current filters. Try adjusting your search criteria or clear all filters to see more results.
                                                            </p>
                                                        </div>
                                                        <div className="flex gap-3 mt-4">
                                                            <button
                                                                onClick={() => {
                                                                    setClientId("");
                                                                    setStatusId([]);
                                                                    setFromDate('');
                                                                    setToDate('');
                                                                    setTeamleadId('');
                                                                    setRecruiterId('');
                                                                    if (currentUser.role === 'admin') { setManagerId('') }
                                                                    setActiveIndex('All');
                                                                    setCurrentPage(1);
                                                                    setScheduledDate({
                                                                        from: '', to: ''
                                                                    })
                                                                    setJoinedDate({
                                                                        from: '', to: ''
                                                                    })
                                                                    // setShowJoinedDateFilter(false)
                                                                    setShowScheduledDateFilter(false)
                                                                    setClientManager("")
                                                                    setJobStatus("")
                                                                        setShowTeamManagerFillter(false)
                                                                        setShowUpdatedByFilter(false)
                                                                        setJobStatusFilter(false)
                                                                        setSanSpocFilter(false)
                                                                        setShowClientFilter(false)
                                                                        setShowClientSpocFilter(false)
                                                                        setEmailId('')
                                                                        setMobileNumber('')
                                                                        setJobName('')
                                                                        setJobStatus('')
                                                                        setCandidateName('')
                                                                }}
                                                                className="px-4 py-2 bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white rounded-lg font-semibold text-sm shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200"
                                                            >
                                                                Clear All Filters
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}

            </div>

          

            {/* <Pagination setRequirement={setRequirement} mode="recruitmentReport" setPaginationData={setPaginationInfo} /> */}

            <div className="mt-6 bg-gradient-to-br from-white to-slate-50/50 rounded-2xl shadow-lg border border-slate-200/60 p-5">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                    {/* Records per page */}
                    <div className="flex items-center gap-3">
                        <label htmlFor="recordsPerPage" className="text-sm font-semibold text-slate-700 whitespace-nowrap">
                            Records per page:
                        </label>
                        <select
                            id="recordsPerPage"
                            value={rowsPerPage}
                            onChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
                            className="px-3 py-1 border-[1px] border-primary-100 rounded-lg bg-white text-slate-700 font-semibold text-sm cursor-pointer hover:border-primary-400 focus:border-primary-500 focus:ring-[1px] focus:ring-primary-100 transition-all outline-none shadow-sm"
                        >
                            {[10, 20, 25, 50, 75, 100].map((n) => (
                                <option key={n} value={n} className="py-2">
                                    {n}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Page navigation */}
                    <div className="flex items-center gap-4">
                        <button
                            className={`flex items-center justify-center w-10 h-10 rounded-xl transition-all duration-200 ${currentPage === 1
                                ? "bg-slate-100 text-slate-400 cursor-not-allowed"
                                : "bg-gradient-to-r from-primary-500 to-primary-600 text-white hover:from-primary-600 hover:to-primary-700 shadow-md hover:shadow-lg transform hover:scale-105 active:scale-95"
                                }`}
                            onClick={() => handlePagination("prev")}
                            disabled={currentPage === 1}
                        >
                            <span className="material-symbols-outlined text-2xl">chevron_left</span>
                        </button>

                        <div className="px-5 py-2 bg-gradient-to-r from-primary-700 to-blue-200 border-[1px] border-primary-100 rounded-lg">
                            <span className="text-sm font-bold text-slate-700">
                                Page <span className="text-primary-600">{currentPage}</span> of <span className="text-primary-600">{totalPage || 0}</span>
                            </span>
                        </div>

                        <button
                            className={`flex items-center justify-center w-10 h-10 rounded-xl transition-all duration-200 ${currentPage === totalPage
                                ? "bg-slate-100 text-slate-400 cursor-not-allowed"
                                : "bg-gradient-to-r from-primary-500 to-primary-600 text-white hover:from-primary-600 hover:to-primary-700 shadow-md hover:shadow-lg transform hover:scale-105 active:scale-95"
                                }`}
                            onClick={() => handlePagination("next")}
                            disabled={currentPage === totalPage}
                        >
                            <span className="material-symbols-outlined text-2xl">chevron_right</span>
                        </button>
                    </div>

                    {/* Total count */}
                    <div className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-lg">
                        <span className="text-sm font-semibold text-slate-600">Total:</span>
                        <span className="text-sm font-bold text-green-600">{perPageTotal || 0}</span>
                        <span className="text-slate-400">/</span>
                        <span className="text-sm font-bold text-green-600">{total || 0}</span>
                    </div>
                </div>

            </div>
            {
                profileHistory?.length > 0 &&
                <ProfileHistoryList profileHistory={profileHistory} setProfileHistory={setProfileHistory} />
            }

            {/* Profile Submission */}
            {showSubmission && (
                <div className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center">
                    <div className="bg-white p-6 rounded-lg w-full space-y-2 max-w-xl m-2 overflow-y-scroll max-h-[500px]">

                        <h3 className="text-xl text-center font-semibold text-primary-400">
                            Profile Submission
                        </h3>

                        <ProfileSubmission
                            candidateId={selectedData.candidateId}
                            jobId={selectedData.jobId}
                            BeURL={BeURL}
                            showAlert={showAlert}
                            processType="submission"
                            setShow={setShowSubmission}
                    refreshProfiles ={ () => safeFetchRequirement({
                        BeURL,
                        setRequirement,
                        showAlert,
                        activeIndex,
                        id,
                        currentPage,
                        rowsPerPage,
                        setTotal,
                        setTotalPage,
                        setPerPageTotal,
                        clientId,
                        managerId,
                        teamleadId,
                        recruiterId,
                        clientManager,
                        jobName,
                        updatedByRecruiterId,
                        candidateName,
                        mobileNumber,
                        emailId,
                        jobStatus,
                        sanSpocId,
                        statusId,
                        fromDate,
                        toDate,
                        scheduledDate,
                        joinedDate,
                        submittedOn,
                        setLoading
                    })}
                        />
                    </div>
                </div>
            )}
        </div >
    );
};

